import { supabase } from './supabase.js';

// เรียก /api/* ด้วย session ปัจจุบัน (ก็อปแบบเดียวกับที่ QuickBuy ใช้ในไฟล์ตัวเอง)
export async function authFetch(path, opts = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('เซสชันหมดอายุ — ล็อกอินใหม่');
  const res = await fetch(path, {
    ...opts,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}`, ...(opts.headers || {}) },
  });
  const out = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(out.error || `error ${res.status}`);
  return out;
}
